import { lighten } from '@mui/material';
import { useTheme } from '@mui/material/styles';

export function usePaperBackgroundColor(elevation: number = 0) {
  const theme = useTheme();
  const color = theme.palette.background.paper;
  switch (elevation) {
    case 8:
    case 24:
      return theme.palette.mode === 'dark' ? lighten(color, 0.08) : color;
    case 0:
    default:
      return color;
  }
}
